namespace GeniuzPOS.Member {
    export namespace MbReportSaleByDateService {
        export const baseUrl = 'Member/MbReportSaleByDate';

        export declare function Create(request: Serenity.SaveRequest<MbReportSaleByDateRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<MbReportSaleByDateRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<MbReportSaleByDateRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<MbReportSaleByDateRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Member/MbReportSaleByDate/Create",
            Update = "Member/MbReportSaleByDate/Update",
            Delete = "Member/MbReportSaleByDate/Delete",
            Retrieve = "Member/MbReportSaleByDate/Retrieve",
            List = "Member/MbReportSaleByDate/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>MbReportSaleByDateService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
